import React, { useEffect, useState } from "react";
import { Severty, ShowToast } from "../helper/toast";
import apiPath from "../constants/apiPath";
import useRequest from "../hooks/useRequest";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const PLACEHOLDER_REGEX = /{{\s*[\w.]+\s*}}/g;

const extractPlaceholders = (text) => text.match(PLACEHOLDER_REGEX) || [];

const TemplateEditor = ({ template, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [originalPlaceholders, setOriginalPlaceholders] = useState({
    subject: [],
    body: [],
  });

  useEffect(() => {
    setSubject(template.subject);
    setBody(template.body_html);

    setOriginalPlaceholders({
      subject: extractPlaceholders(template.subject),
      body: extractPlaceholders(template.body_html),
    });
  }, [template]);

  const validatePlaceholders = () => {
    const currentSubject = extractPlaceholders(subject);
    const currentBody = extractPlaceholders(body);

    const subjectValid = originalPlaceholders.subject.every((p) =>
      currentSubject.includes(p)
    );

    const bodyValid = originalPlaceholders.body.every((p) =>
      currentBody.includes(p)
    );

    return subjectValid && bodyValid;
  };

  const handleSave = async () => {
    if (!validatePlaceholders()) {
      ShowToast(
        "You cannot remove or change placeholders like {{user_name}}",
        Severty.ERROR
      );
      return;
    }
    setLoading(true);
    const payload = {
      subject,
      body_html: body,
      is_active: template.is_active,
    };
    request({
      url: `/api/admin/email-template/${template.id}`,
      method: "PUT",
      data: payload,
      onSuccess: (data) => {
        console.log("data update template--->", data);
        setLoading(false);
        ShowToast("Template updated successfully", Severty.SUCCESS);
        onUpdate();
      },
      onError: (error) => {
        setLoading(false);
        ShowToast("Failed to update email template", Severty.ERROR);
      },
    });
  };

  // Custom toolbar configuration for React Quill
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  return (
    <div className="template-editor-wrapper">
      <h3>Edit Template</h3>

      <div className="form-group">
        <label>
          <strong>Subject</strong>
        </label>
        <input
          className="editor-subject-input form-control"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Email subject"
        />
      </div>

      <div className="form-group">
        <label>
          <strong>Email Body</strong>
        </label>
        <ReactQuill
          theme="snow"
          value={body}
          onChange={setBody}
          modules={modules}
          formats={formats}
          className="email-body-editor"
        />
      </div>

      <div className="placeholders-section">
        <h4>Available Placeholders</h4>
        <div className="placeholder-info">
          <p>
            You can use these placeholders in your template. They will be
            replaced with actual values when the email is sent.
          </p>
        </div>
        <div className="placeholder-groups">
          <div className="placeholder-group">
            <h5>Subject Placeholders</h5>
            <div className="placeholder-list">
              {originalPlaceholders.subject.map((p, index) => (
                <span
                  key={index}
                  className="placeholder-chip badge bg-secondary me-2 mb-2"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>

          <div className="placeholder-group">
            <h5>Body Placeholders</h5>
            <div className="placeholder-list">
              {originalPlaceholders.body.map((p, index) => (
                <span
                  key={index}
                  className="placeholder-chip badge bg-secondary me-2 mb-2"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="editor-actions mt-3">
        <button
          onClick={handleSave}
          disabled={loading}
          className="btn btn-primary"
        >
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default TemplateEditor;
